import React, { useCallback, useEffect, useState } from 'react';
import Select from '../Select';
import PhoneNumberInput from '../PhoneNumberInput';

import FileUpload from '../FileUpload';
import TextField from '@mui/material/TextField';

import './index.scss';
import Datepicker from '../Datepicker';

/*
 input types: [
 text,
 email,
 select,
 file,
 date,
 time,
 textarea,
 ]
 */



const Input = ({ field, onChange, reset }) => {
  const { slug, type, name, list, multiple, validation, hasError } = field;
  const [searchTerm, setSearchTerm] = useState(null);
  const [isValid, setIsValid] = useState(!hasError);

  useEffect(() => {
    if (reset) {
      switch (type) {
        case 'select':
          setSearchTerm('');
          break;
        case 'phone':
          setSearchTerm('');
          break;
        case 'textarea':
          setSearchTerm('');
          break;
        case 'file':
          setSearchTerm('');
          break;
        case 'date':
          setSearchTerm(null);
          break;
        case 'time':
          setSearchTerm(null);
          break;
        default:
          setSearchTerm('');
          break;
      }
    }

  }, [reset, type]);

  useEffect(() => {
    setIsValid(!hasError)
  }, [hasError]);

  const handleInput = (e) => {
    const val = slug === 'website' ? e.target.value.trim() : e.target.value.trimStart();
    setSearchTerm(val);

    if (val !== null) {
      if (!!val) {
        if (validation.regex
          ? val.match(validation.regex) &&
          (validation.min ? val.length >= validation.min : true) &&
          (validation.max ? val.length <= validation.max : true)
          : true) {
          onChange({ [slug]: val });
          setIsValid(true);
        } else {
          setIsValid(false);
        }
      } else {
        setIsValid(!validation.required);
        onChange({ [slug]: undefined });
      }
    }
  }

  const handleSelect = (e) => {
    setIsValid(!!e.length);
    onChange({ [slug]: e });
  }

  const handlePhoneSelect = (e) => {
    if (!!e['phone.number']) {
      if ((e['phone.number'].length >= validation.min && e['phone.number'].length <= validation.max) && e['phone.number'].match(validation.regex)) {
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    }

    onChange(e);
  }

  const dateHandler = useCallback((e) => {
    const date = new Date(e);
    const dayOfWeek = date.getDay();
    const num = +`${date.getHours()}${date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()}`;
    const isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0)

    setIsValid(!isWeekend && (num < 1800 && num > 900));
    onChange({ meetingDate: e });
  }, []);

  return (
    <div className={`input-wrapper input-wrapper-${type} ${!isValid ? 'invalid' : ''}`}>
      {
        type === 'select'
          ? <Select hasError={!isValid} reset={reset} slug={slug} name={validation.required ? `${name}*` : name}
                    list={list} multiple={multiple} onChange={handleSelect}/>
          : type === 'phone'
            ? <PhoneNumberInput hasError={!isValid} reset={reset} value={searchTerm} list={list} name={name}
                                onChange={handlePhoneSelect}/>
            : type === 'textarea'
              ? <TextField multiline
                           value={searchTerm}
                           minRows={3}
                           label={`${name}*`}
                           error={!isValid}
                           onChange={handleInput}/>
              : type === 'file'
                ?
                <FileUpload reset={reset} name={name} slug={slug} type={type} onChange={(e) => onChange({ [slug]: e })}/>
                : type === 'dateTime'
                    ? <Datepicker name={name} onChange={dateHandler} hasError={!isValid} reset={reset} />
                    : <TextField
                      label={validation.required ? `${name}*` : name}
                      variant="outlined"
                      value={searchTerm}
                      error={!isValid}
                      onChange={handleInput}/>

      }
      {!isValid ? <span className="err-msg">{validation?.error}</span> : null}
      {type === 'dateTime' && isValid ? <span className="hint-msg">{validation?.hint}</span> : null}
    </div>
  );
};

export default Input;
